import { useEffect, useState } from 'react';
import Brands from '../components/Brands/brandsSection';
// import FlashSales from '../components/FlashSales/FlashSalesSection';
import Footer from '../components/Footer/FooterSection';
import Header from '../components/Header/HeaderSection';
import HeroSection from '../components/Hero/HeroSection';
import NewsletterSection from '../components/Newsletter/NewsletterSection';
import Products from '../components/Products/ProductsSection';
import { loadBanners, loadBestSelling, loadCategories, loadNewArrivals, loadRecommended } from '../api/requests';
import { Banner, Product, ProductCategory } from '../interface/interfaces';


const Homepage = () => {

    const [isPageLoading, setPageLoader] = useState(true)
    const [banners, setBanners] = useState<Banner[]>([])
    const [newArrivalsData, setNewArrivals] = useState<Product[]>([])
    const [bestSellingData, setBestSelling] = useState<Product[]>([])
    // const [flashSales, setFlashSales] = useState<Product[]>([])
    const [recommended, setRecommended] = useState<Product[]>([])
    const [categories,setCategories]=useState<ProductCategory[]>([])



    // Load content
    useEffect(() => {

        const initFunc = async () => {

            try {
                const [banners, newArrivals, bestSelling, recommended,categories] = await Promise.all([
                    loadBanners(),
                    loadNewArrivals(1, 5),
                    loadBestSelling(1, 5),
                    // loadFlashsales(1, 10),
                    loadRecommended(),
                    loadCategories()
                ]);


                setBanners(banners)
                setNewArrivals(newArrivals.products)
                setBestSelling(bestSelling.products)
                // setFlashSales(flashSales.products)
                setRecommended(recommended.products)
                setCategories(categories)



                // console.log('Banners', banners);
                // console.log('New Arrivals', newArrivals);
                // console.log('Best Selling', bestSelling);
                // console.log('Flash Sales', flashSales);
                // console.log('Recommended', recommended);


            } catch (error) {

            } finally {
                setPageLoader(false)
            }

        }

        initFunc()

    }, [])


    return (
        <div className='animate__animated animate__fadeIn animate__fast'>
            <Header></Header>
            <div className='content'>
                <HeroSection isBannerLoading={isPageLoading} categories={categories} bannersData={banners}></HeroSection>
                <Products title='New Arrivals' isLoading={isPageLoading} products={newArrivalsData} setProducts={setNewArrivals} fullUrl='/viewall/new'></Products>
                <Products title='Best Sellers' isLoading={isPageLoading} products={bestSellingData} setProducts={setBestSelling} fullUrl='/viewall/bestsellers'></Products>
            </div>

            {/* <FlashSales dateString={null} isLoading={isPageLoading} products={flashSales} setProducts={setFlashSales} fullUrl='/viewall/flashsales' ></FlashSales> */}

            <div className='content'>

                {/* <Deals title="Today's best deals" deals={[]} fullUrl='/viewall/deals'></Deals> */}
                <Products title='Recommended Items' isLoading={isPageLoading} products={recommended} setProducts={setRecommended} fullUrl='/viewall/recommended'></Products>
                <Brands></Brands>
                <NewsletterSection></NewsletterSection>

            </div>

            <Footer></Footer>

        </div>
    )

}

export default Homepage;